export const USER_SETTINGS_LINKS = {
  SUPPORT_EMAIL: 'support@predocai.com',
  PRIVACY_POLICY_URL:
    'https://cdn.prod.website-files.com/6827c1994862c627993a82d8/689b1d65a78dcb11fd4ec394_privacy-policy.pdf',
} as const;

// API endpoints
export const API_ENDPOINTS = {
  UPDATE_EMAIL: '/api/user/update-email',
} as const;

// Query keys for TanStack Query
export const QUERY_KEYS = {
  USER_PROFILE: ['userProfile'],
} as const;

// Toast messages
export const TOAST_MESSAGES = {
  EMAIL_UPDATE_SUCCESS: 'Email updated successfully',
  EMAIL_UPDATE_ERROR: 'Failed to update email',
  NAME_UPDATE_SUCCESS: 'Name updated successfully',
  NAME_UPDATE_ERROR: 'Failed to update name',
  PASSWORD_UPDATE_SUCCESS: 'Password updated successfully',
  PASSWORD_UPDATE_ERROR: 'Failed to update password',
} as const;
